import classNames from 'classnames'
import type { FunctionalComponent, HTMLAttributes } from 'vue'
import './CharComp.scss'

export const CharComp: FunctionalComponent<HTMLAttributes> = (_props, { slots, attrs }) => {
  return (
    <span {...attrs} class={classNames('char-comp', attrs.class as string)}>
      {slots.default?.()}
    </span>
  )
}
CharComp.inheritAttrs = false
